export default __webpack_public_path__ + "static/media/er.5e3dc854.svg";